var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1001,
    viewBox: "0 0 1001 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    y: 0.382812,
    width: 999.997,
    height: 999.997,
    rx: 499.998,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M714.492 446.532L554.126 286.166L634.91 205.383L795.276 205.381L795.275 365.749L714.492 446.532Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M714.49 554.231L554.124 714.596L634.91 795.381L795.277 795.382L795.275 635.016L714.49 554.231Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.624 795.381L660.625 500.381L365.627 205.383L205.276 205.381L205.277 365.749L339.91 500.382L205.277 635.015L205.275 795.382L365.624 795.381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXUsd);
export default __webpack_public_path__ + "static/media/xUsd.229eae67d9c70347ae8f408dfe1b9fb2.svg";
export { ForwardRef as ReactComponent };